import { FC, ReactNode, useState } from 'react';
import CarouselCard from './CarouselCard';

const scrollBarWidthREM = 16;
const scrollProgressWidthREM = 4;

interface Props {
  children: (ReactNode & { key: any })[];
  isWidthScreen?: boolean;
  justify?: 'start' | 'center';
}

const Carousel: FC<Props> = ({
  children,
  isWidthScreen = false,
  justify = 'start',
}) => {
  const [progress, setProgress] = useState<number>(0);
  const [showProgress, setShowProgress] = useState(true);

  const handleScroll = (event: any) => {
    const left = event?.target?.scrollLeft ?? 0;
    const scrollWidth = event?.target?.scrollWidth ?? 1;
    const clientWidth = event?.target?.clientWidth ?? 0;
    setProgress(left / (scrollWidth - clientWidth));
  };

  return (
    <div className="flex flex-col px-12">
      <div
        ref={(el) => setShowProgress(el?.clientWidth < el?.scrollWidth)}
        className={`${
          isWidthScreen ? 'w-screen' : 'w-full'
        } lg:w-full px-4 flex gap-[0.625rem] justify-${justify} overflow-x-scroll scrollbar-none scroll-smooth`}
        onScroll={handleScroll}
      >
        {children.map((child) => (
          <CarouselCard key={child.key}>{child}</CarouselCard>
        ))}
      </div>

      {showProgress && (
        <div className="flex justify-center items-center">
          <div className="relative mt-[23px]">
            <div
              className={`h-[4px] rounded-full bg-neutral-300`}
              style={{
                width: `${scrollBarWidthREM}rem`,
              }}
            ></div>

            <div
              className={`absolute h-[4px] rounded-full bg-red-600 left-0 top-0`}
              style={{
                width: `${scrollProgressWidthREM}rem`,
                transform: `translate(${
                  progress * (scrollBarWidthREM - scrollProgressWidthREM)
                }rem, 0)`,
              }}
            ></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Carousel;
